/**
 * GMOセッション再利用検出 - SPA起動前リダイレクト
 *
 * GMO APIが前回セッションのcancel/complete URLを再利用して
 * 間違ったページにリダイレクトした場合、React/F7が起動する前に
 * 正しいURLへリダイレクトする。
 *
 * main.tsxの先頭でimportすることで、ReactDOM.render()より前に実行される。
 * これにより白画面フラッシュや間違ったページの一瞬表示を防止する。
 */
(function checkGmoSessionReuse() {
  const path = window.location.pathname;
  const expectedReturn = localStorage.getItem('gmo_expected_return');
  const expectedCancel = localStorage.getItem('gmo_expected_cancel');

  if (!expectedReturn && !expectedCancel) return;

  const saveAndRedirect = (targetUrl: string) => {
    // 後続のcleanupがfromPageを消す前に退避キーに保存
    const fromPage = localStorage.getItem('fromPage');
    if (fromPage) {
      localStorage.setItem('gmo_redirect_fromPage', fromPage);
    }
    localStorage.removeItem('gmo_expected_return');
    localStorage.removeItem('gmo_expected_cancel');
    window.location.replace(targetUrl);
  };

  // PrepaidSettings: /prepaid_settings/gmo_success or /prepaid_settings/gmo_cancel
  if (
    path.includes('/prepaid_settings/gmo_success') &&
    expectedReturn &&
    !expectedReturn.includes('/prepaid_settings/')
  ) {
    saveAndRedirect(expectedReturn);
    return;
  }
  if (
    path.includes('/prepaid_settings/gmo_cancel') &&
    expectedCancel &&
    !expectedCancel.includes('/prepaid_settings/')
  ) {
    saveAndRedirect(expectedCancel);
    return;
  }

  // AccountRegistPayment: /account_payment_regist/gmo_success
  if (
    path.includes('/account_payment_regist/gmo_success') &&
    expectedReturn &&
    !expectedReturn.includes('/account_payment_regist/')
  ) {
    saveAndRedirect(expectedReturn);
    return;
  }
  // AccountRegistPayment cancel: /account_payment_regist/ (statusなし)
  if (
    /^\/account_payment_regist\/?$/.test(path) &&
    expectedCancel &&
    !expectedCancel.includes('/account_payment_regist')
  ) {
    saveAndRedirect(expectedCancel);
    return;
  }

  // 正しいページに到着した場合、期待URLをクリーンアップ
  localStorage.removeItem('gmo_expected_return');
  localStorage.removeItem('gmo_expected_cancel');
})();

export {};
